import { useEffect, useState } from 'react';
import styled from 'styled-components';

const ProgressWrapper = styled.div`
    background-color: ${({ theme }) => theme.gray_5};
    border-radius: 100px;
`;

const ProgressValue = styled.div.attrs(({ value }) => ({
    style: { width: `${value}%` },
}))`
    display: block;
    background-color: ${({ theme }) => theme.purple_1};
    transition: width 100ms;
    min-width: 5%;
    height: 10px;
    border-radius: 100px;
`;

function DelayRender({ delay = 200, children }) {
    const [isDelayed, setIsDelayed] = useState(true);

    useEffect(() => {
        const timer = setTimeout(setIsDelayed, 200, false);
        return () => clearTimeout(timer);
    }, [setIsDelayed]);

    if (isDelayed) {
        return null;
    }

    return children;
}

// The math here courtesey of https://github.com/piercus/fake-progress
const updateProgress = (start, duration) =>
    1 - Math.exp((-1 * (Date.now() - start)) / duration);

function FakeProgressBar({ duration = 10000 }) {
    const [progress, setProgress] = useState(0);
    const [start] = useState(Date.now() - 100);

    useEffect(() => {
        const interval = setInterval(
            () => setProgress(updateProgress(start, duration)),
            100,
        );
        return () => clearInterval(interval);
    }, [setProgress, duration, start]);

    return (
        <DelayRender>
            <ProgressWrapper>
                <ProgressValue value={progress * 100} />
            </ProgressWrapper>
        </DelayRender>
    );
}

export default FakeProgressBar;
